import { config } from 'lib/config'

export function useFlag(key: string): boolean {
  const featureFlag = config.FEATURE_FLAGS.find((featureFlag: string) => featureFlag === key)

  return featureFlag !== undefined
}
